module.exports = __webpack_public_path__ + "img/logo_black.80d40619.png";